/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FamilyPoolInvitation } from './FamilyPoolInvitation';
import {
    FamilyPoolInvitationFromJSON,
    FamilyPoolInvitationFromJSONTyped,
    FamilyPoolInvitationToJSON,
    FamilyPoolInvitationToJSONTyped,
} from './FamilyPoolInvitation';

/**
 * 
 * @export
 * @interface FamilyPoolInvitationListResponse
 */
export interface FamilyPoolInvitationListResponse {
    /**
     * 
     * @type {Array<FamilyPoolInvitation>}
     * @memberof FamilyPoolInvitationListResponse
     */
    items?: Array<FamilyPoolInvitation>;
}

/**
 * Check if a given object implements the FamilyPoolInvitationListResponse interface.
 */
export function instanceOfFamilyPoolInvitationListResponse(value: object): value is FamilyPoolInvitationListResponse {
    return true;
}

export function FamilyPoolInvitationListResponseFromJSON(json: any): FamilyPoolInvitationListResponse {
    return FamilyPoolInvitationListResponseFromJSONTyped(json, false);
}

export function FamilyPoolInvitationListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyPoolInvitationListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(FamilyPoolInvitationFromJSON)),
    };
}

export function FamilyPoolInvitationListResponseToJSON(json: any): FamilyPoolInvitationListResponse {
    return FamilyPoolInvitationListResponseToJSONTyped(json, false);
}

export function FamilyPoolInvitationListResponseToJSONTyped(value?: FamilyPoolInvitationListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(FamilyPoolInvitationToJSON)),
    };
}

